/**
 * Sort curriculum year nodes: numeric "Year N" first (by N), then other labels alphabetically.
 * E180 uses e180_YearLabel; E179 uses e179_Number / e179_Name (Oak library).
 */
function parseYearSortKey(y: any, isE180: boolean): { n: number | null; label: string } {
  if (isE180) {
    const lab = (y.e180_YearLabel as string)?.trim() || '';
    const m = /^Year\s+(\d+)$/i.exec(lab);
    if (m) return { n: parseInt(m[1], 10), label: lab };
    return { n: null, label: lab };
  }
  const num = y.e179_Number;
  if (num != null && num !== undefined) {
    return { n: Number(num), label: `Year ${num}` };
  }
  const name = (y.e179_Name as string)?.trim() || '';
  return { n: null, label: name };
}

export function sortYears(years: any[], isE180: boolean = false): any[] {
  return [...years].sort((a, b) => {
    const ka = parseYearSortKey(a, isE180);
    const kb = parseYearSortKey(b, isE180);
    if (ka.n != null && kb.n != null) return ka.n - kb.n;
    if (ka.n != null) return -1;
    if (kb.n != null) return 1;
    return ka.label.localeCompare(kb.label, undefined, { sensitivity: 'base' });
  });
}
